import { render, staticRenderFns } from "./AllRelations.vue?vue&type=template&id=4fa05082&scoped=true&"
import script from "./AllRelations.vue?vue&type=script&lang=ts&"
export * from "./AllRelations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa05082",
  null
  
)

export default component.exports